export const downloadBlob = (blob: Blob, filename: string): void => {
    /*eslint-disable */
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (navigator as any).msSaveOrOpenBlob(blob, filename);
        /*eslint-enable */
        return;
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.download = filename;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Revoking right away can cancel the download in some browsers before it has started.
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
};
